// extracted by mini-css-extract-plugin
export default {"section":"HomaBrand_section__jxJyi","logo":"HomaBrand_logo__CoicH","title":"HomaBrand_title__D-Z-D","description":"HomaBrand_description__d9el0"};